import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';
import useAppState from '../state/appState';
import { PetClaimsData } from '../types/services';
import { getPetClaimsServiceConfig } from '../services/petClaims';
import { WhichAnimalTypeMap } from '../components/custom/PetSelector/utils';
import { logError } from '../utils/logger';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    const petClaimsData = await getPetClaimsData();
    const petType = getValueOrDefault(formConfig, formValues, 'whichAnimalType').value;
    const mapPetType = WhichAnimalTypeMap[petType];

    switch (curPageId) {
        case 'godt-at-vide':
            return 'vaelg-type';

        case 'vaelg-type':
            if (petClaimsData?.length) {
                const petClaimsCount = petClaimsData.filter((petClaim) => petClaim.animalType === mapPetType).length;
                if (petClaimsCount > 0) {
                    return 'tidligere-anmeldelse';
                }
            }

            return 'vaelg-dyr';

        case 'tidligere-anmeldelse':
            if (getValueOrDefault(formConfig, formValues, 'animalsicknessexistingclaimswidget').value === 'new-claim') {
                return 'vaelg-dyr';
            }
            return 'beskriv-aenderingerne';

        case 'vaelg-dyr':
            if (getValueOrDefault(formConfig, formValues, 'whichAnimalType').value === 'Hest') {
                return 'dato';
            }
            return 'om-skaden';

        case 'om-skaden':
            return 'dato';

        case 'dato':
            return 'beskriv-skaden';

        case 'beskriv-skaden':
            return 'betaling-for-behandling';

        case 'betaling-for-behandling':
            return 'dokumentation';

        case 'beskriv-aenderingerne':
            return 'betaling-for-anden-behandling';

        case 'betaling-for-anden-behandling':
            return 'dokumentation';

        case 'dokumentation':
            if (!getValueOrDefault(formConfig, formValues, 'dateOfLoss')) {
                return 'om-dig';
            }

            return 'andet-selskab';

        case 'andet-selskab':
            if (
                getValueOrDefault(formConfig, formValues, 'harduenforsikringietandetselskabsomdkkerdetsamme').value ===
                'Ja'
            ) {
                return 'hvilket-selskab';
            }
            return 'om-dig';

        case 'hvilket-selskab':
            return 'om-dig';

        case 'om-dig':
            return 'resume';

        case 'resume':
            return undefined;

        default:
            throw new Error('Unknown page: ' + curPageId);
    }
};

const getPetClaimsData = async () => {
    const { topConfig, petClaimsData, setPetClaimsData } = useAppState.getState();

    if (topConfig) {
        if (!petClaimsData) {
            try {
                const response: PetClaimsData[] | undefined = await getPetClaimsServiceConfig(topConfig);
                setPetClaimsData(response ?? []);
            } catch (error) {
                logError(`Animal sickness claim cannot be fetched, assuming no claims: ${error}`);
                setPetClaimsData([]);
            }
        }
    }

    return petClaimsData;
};
